(function($) {
    $(function() {
      $("#b2b_app_password").attr('type','password');
      // Pagination customization start
      $(document).on('change', '#products_per_page', function() {
          var perPage = $(this).val();
          $(this).parent().find('.limiter-count').html(perPage);
          var perPageData = '{"attributes":{"collection_products_per_page":"'+perPage+'"}}';
          $.ajax({
              url: "/cart/update.js",
              type: "post",
              data: perPageData,
              contentType: "application/json",
              success: function(result) {
                  var queryParams = window.location.search;
                  if (queryParams.indexOf("page=")) {
                    const params = new URLSearchParams(window.location.search);
                    params.delete("page");
                    var newUrl = window.location.origin+window.location.pathname;
                    if (params.size) {
                      newUrl = newUrl+'?'+params;
                    }
                    window.location.href = newUrl;
                  } else {
                    location.reload();
                  }
              }
          });
      });
      // move qty and add to cart into one element
      if ($("body").hasClass('product-page')) {
          $(".product-form__buttons").prepend($("<div class='qty-add-to-cart'></div>"));
          $("div[id*='Quantity-Form-template']").addClass('qty-selector').appendTo(".qty-add-to-cart");
          $(".product-form__submit.button.button--secondary").addClass('add-to-cart-button').appendTo(".qty-add-to-cart");
      }
      // hide empty tabs on PDP
            $(".product__accordion.accordion.quick-add-hidden").each(function() {
                if ($(this).find(".accordion__content").text().trim() == '') {
                    $(this).addClass('hidden');
                }
            });
    });
})(jQuery);
